import React from 'react';
import { BufferGeometry } from 'three';

import { layoutColors } from './layoutColors';
import { LayoutSolidVisual } from './LayoutSolidVisual';

export function OverhangSolidVisual(props: { geometry: BufferGeometry; wireframe?: boolean }) {
  return (
    <LayoutSolidVisual
      geometry={props.geometry}
      meshColor={layoutColors.overhangs}
      wireframe={props.wireframe}
      edgeColor={props.wireframe ? layoutColors.overhangs : layoutColors.solidMeshEdges}
    />
  );
}
